var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipServiceType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12C22.5 17.8 17.8 22.5 12 22.5C6.2 22.5 1.5 17.8 1.5 12C1.5 6.2 6.2 1.5 12 1.5C17.8 1.5 22.5 6.21 22.5 12Z",
    fill: "#99A1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.42 9.9V14.1C16.42 14.55 16.2 14.85 15.9 15.07L12.52 17.1C12.37 17.17 12.15 17.25 12 17.25C11.85 17.25 11.62 17.17 11.47 17.1L8.10001 15.07C7.80001 14.85 7.57001 14.47 7.57001 14.1V9.9C7.57001 9.45 7.80001 9.15 8.10001 8.92L11.47 6.9C11.62 6.82 11.77 6.75 12 6.75C12.23 6.75 12.37 6.82 12.6 6.9L15.97 8.92C16.27 9.15 16.5 9.52 16.42 9.9Z",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
    fill: "#99A1AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipServiceType);
export default __webpack_public_path__ + "static/media/ic-chip-service-type.e10e13de0efd17d98c7c530d52f370ad.svg";
export { ForwardRef as ReactComponent };